import api from "../store/services/api";

class CustomerService {
  getCustomers = async (params) => {
    try {
      return await api.get(`/customers/`, { params });
    } catch (e) {}
  };

  getCustomersReportData = (params) => {
    return api.get("/new/top-customer/", { params });
  };

  getCustomersSpentReportData = (params) => {
    return api.get("/new/top-customer-spent/", { params });
  };

  createCustomer = async (customer) => {
    return await api.post(`/customers/`, customer, {
      headers: { "Content-Type": "application/json" },
    });
  };

  editCustomer = async (customer, customerId) => {
    return await api.put(`/customers/?cid=${customerId}`, customer, {
      headers: { "Content-Type": "application/json" },
    });
  };

  deleteCustomer = (customerId) => {
    return api.delete(`/customers/?cid=${customerId}`);
  };

  setCustomerBlacklist = async (customerId, isBlacklisted) => {
    return await api.put(
      `/customers/${customerId}/blacklist/`,
      { is_blacklisted: isBlacklisted },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  customerAddress = async (customer_id) => {
    try {
      return await api.get(`/addresses/?cid=${customer_id}`);
    } catch (e) {}
  };

  customerReport = async (customer_id, params = undefined) => {
    try {
      return await api.get(`/customers/${customer_id}/report`, { params });
    } catch (e) {}
  };

  getCustomerPastOrders = async (customer_id) => {
    return await api.get(`/customers/${customer_id}/past-orders/`);
  };
}

export default new CustomerService();
